<p-breadcrumb class="max-w-full" [model]="breadcrumbData">
    <ng-template pTemplate="item" let-item>
        <ng-container *ngIf="!isLastItem(item); else elseBlock">
            <a [routerLink]="item.routerLink" [queryParams]="item?.queryParams" class="p-menuitem-link current-page" (click)="updateBreadcrumb(item.label)">
                <span [ngClass]="[item.icon ? item.icon : '', 'text-color']"></span>
                <span class="current-page">{{ item.label }}</span>
            </a>
        </ng-container>
        <ng-template #elseBlock>
                <span class="cursor-auto">{{ item.label }}</span>
        </ng-template>
    </ng-template>
</p-breadcrumb>